export default defineNuxtRouteMiddleware(async (nuxt) => {
  if (!useAuthStore().isAuthorized) {
    useAuthStore().clearTokens();

    const isFromRevampPath = /revamp/.test(nuxt.path);

    return navigateTo({ path: `${isFromRevampPath ? "/revamp" : ""}/login` });
  }
});
